import { SUBMIT_RFR } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, ActionPayload } from "../../types";

export interface SubmitRfrState extends BaseAsyncReducerState {
    success: null | boolean;
    response: Record<string, unknown>;
    torfr?: boolean;
}

// Define an initial state value for the app
const initialState: SubmitRfrState = {
    loading: false,
    error: false,
    success: false,
    response: {},
    torfr: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function submitRfrReducer(state = initialState, action: AppAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case SUBMIT_RFR.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
                torfr: false
            }
        case SUBMIT_RFR.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                response: { ...payload as ActionPayload },
                loading: false,
                error: false,
                success: true,
            }
        case SUBMIT_RFR.ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                success: false,
                torfr: false
            }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default submitRfrReducer;
